
export type Language = "en" | "am" | "fr" | "ar" | "es" | "zh-CN" | "hi";

export const translations: Record<Language, Record<string, string>> = {
    en: {
        darkMode: "Dark Mode",
        lightMode: "Light Mode",
        colorTheme: "Color Theme",
        playbackSettings: "Playback Settings",
        playtime: "Playtime",
        autoPlayNext: "Auto-Play Next",
        minVotes: "Min. Votes ",
        displaySettings: "Display Settings",
        fontSize: "Font Size",
        highContrast: "High Contrast Mode",
        hideBalance: "Hide Balance",
        reset: "Reset to Default",
        join: "Join",
        joinPlaylist: "Join Playlist",
        create: "Create",
        createPlaylist: "Create Playlist",
        activity: "Activity",
        suggest: "Suggest",
        suggestSongs: "Suggest Songs",
        queue: "Queue",
        choosePlaylist: "Choose Playlist",
        yourLibrary: "Your Library",
        suggestions: "Suggestions",
        recentlyJoined: "Recently Joined",
        joined: "Joined",
        mySessions: "My Sessions",
        noSessions: "No sessions yet",
        publicPlaylists: "Public Playlists",
        playlistsHistory: "Playlists History",
        recentActivities: "Recent Activities",
        songSuggestions: "Song Suggestions",
        panel: "Panel",
        loadingPlaylists: "Loading your playlists...",
        viewDetails: "View Details",
        removeSong: "Remove Song",
        noSongs: "No songs available",
        search: "Search",
        "Max Suggestions": "Max Suggestions",
        "Min Celebration Vote": "Min Celebration Vote",
        delete: "Delete",
        "Allow Guests Add Songs": "Allow Guests to Add Songs to Session",
        allowGuestAdd: "Add Songs",
        allowed: "Allowed",
        notAllowed: "Not Allowed",
        on: "On",
        off: "Off",
        language: "Language"       // en
    },
    am: {
        darkMode: "ሌሊት",
        lightMode: "ቀን",
        colorTheme: "ቀለም",
        playbackSettings: "ጫወታ",
        playtime: "የጫወታ ጊዜ",
        autoPlayNext: "ቀጣይ በራስ",
        minVotes: "አነስተኛ ድምጽ",
        displaySettings: "ማሳያ",
        fontSize: "ፊደል",
        highContrast: "ተፅዕኖ",
        hideBalance: "ሂሳብ ደብቅ",
        reset: "እንደመጀመሪያ",
        join: "ተቀላቅል",
        joinPlaylist: "ተቀላቅል",
        create: "ፍጠር",
        createPlaylist: "ዝርዝር ፍጠር",
        activity: "እንቅስቃሴ",
        suggest: "አሳስብ",
        suggestSongs: "ዘፈኖች አሳስብ",
        queue: "ዝርዝር",
        choosePlaylist: "ዝርዝር ምረጥ",
        yourLibrary: "ቤተመጻሕፍት",
        suggestions: "ምክሮች",
        recentlyJoined: "በቅርብ ተቀላቀሉ",
        joined: "ተቀላቅለዋል",
        mySessions: "የእኔ ሴሽኖች",
        noSessions: "እስካሁን ሴሽኖች የሉም",
        publicPlaylists: "የህዝብ ዝርዝሮች",
        playlistsHistory: "ታሪክ",
        recentActivities: "ቅርብ እንቅስቃሴ",
        songSuggestions: "ዘፈኖች ምክሮች",
        panel: "ፓነል",
        loadingPlaylists: "በመጫን ላይ...",
        viewDetails: "ዝርዝር እይ",
        removeSong: "አስወግድ",
        noSongs: "ዘፈኖች የሉም",
        search: "ፈልግ",
        "Max Suggestions": "ከፍ ምክሮች",
        "Min Celebration Vote": "ድምጽ አነስተኛ",
        "Allow Guests Add Songs": "እንግዶች ያካትቱ",
        allowGuestAdd: "እንግዶች ያካትቱ",
        allowed: "ተፈቅዷል",
        notAllowed: "አይፈቀድም",
        on: "ነው",
        off: "ዝግ",
        language: "ቋንቋ",
        delete: "ሰርዝ",

    }
    ,
    fr: {
        darkMode: "Sombre",
        lightMode: "Clair",
        colorTheme: "Thème",
        playbackSettings: "Lecture",
        playtime: "Durée",
        autoPlayNext: "Auto-lect.",
        minVotes: "Votes Min.",
        displaySettings: "Affichage",
        fontSize: "Taille",
        highContrast: "Contraste",
        hideBalance: "Masquer Solde",
        reset: "Réinitialiser",
        join: "Rejoindre",
        joinPlaylist: "Rejoindre",
        create: "Créer",
        createPlaylist: "Créer Playlist",
        activity: "Activité",
        suggest: "Suggérer",
        suggestSongs: "Sugg. Chansons",
        queue: "File",
        choosePlaylist: "Choisir",
        yourLibrary: "Bibliothèque",
        suggestions: "Suggestions",
        recentlyJoined: "Rejoints",
        joined: "Rejoint",
        mySessions: "Mes sessions",
        noSessions: "Aucune session pour le moment",
        publicPlaylists: "Playlists Pub.",
        playlistsHistory: "Hist. Playlist",
        recentActivities: "Activité",
        songSuggestions: "Chansons Sug.",
        "Max Suggestions": "Suggestions max.",
        "Min Celebration Vote": "Vote 🎉 Min.",
        panel: "Panneau",
        loadingPlaylists: "Chargement...",
        viewDetails: "Détails",
        removeSong: "Supprimer",
        noSongs: "Aucune chanson",
        search: "Chercher",
        "Allow Guests Add Songs": "Autoriser les invités à ajouter des chansons",
        allowGuestAdd: "Invités Ajout",
        allowed: "Oui",
        notAllowed: "Non",
        on: "On",
        off: "Off",
        language: "Langue",
        delete: "Supprimer",

    },

    ar: {
        darkMode: "الوضع الداكن",
        lightMode: "الوضع الفاتح",
        colorTheme: "سمة اللون",
        playbackSettings: "إعدادات التشغيل",
        playtime: "مدة التشغيل",
        autoPlayNext: "تشغيل التالي تلقائيًا",
        minVotes: "الحد الأدنى من الأصوات",
        displaySettings: "إعدادات العرض",
        fontSize: "حجم الخط",
        highContrast: "تباين عالي",
        hideBalance: "إخفاء الرصيد",
        reset: "إعادة التعيين",
        join: "انضم",
        joinPlaylist: "انضم إلى القائمة",
        create: "إنشاء",
        createPlaylist: "إنشاء قائمة تشغيل",
        activity: "نشاط",
        suggest: "اقترح",
        suggestSongs: "اقترح أغاني",
        queue: "قائمة الانتظار",
        choosePlaylist: "اختر قائمة تشغيل",
        yourLibrary: "مكتبتك",
        suggestions: "اقتراحات",
        recentlyJoined: "انضم مؤخراً",
        joined: "انضم",
        mySessions: "جلساتي",
        noSessions: "لا توجد جلسات بعد",
        publicPlaylists: "قوائم التشغيل العامة",
        playlistsHistory: "تاريخ قوائم التشغيل",
        recentActivities: "الأنشطة الأخيرة",
        songSuggestions: "اقتراحات الأغاني",
        "Min Celebration Vote": "الحد الأدنى للتصويت (احتفال)",

        panel: "لوحة",
        loadingPlaylists: "جارٍ تحميل قوائم التشغيل…",
        viewDetails: "عرض التفاصيل",
        removeSong: "إزالة الأغنية",
        noSongs: "لا توجد أغانٍ",
        search: "بحث",
        "Max Suggestions": "أقصى عدد من الاقتراحات",
        "Allow Guests Add Songs": "السماح للضيوف بإضافة الأغاني",
        allowGuestAdd: "السماح للضيوف بإضافة الأغاني",
        allowed: "مسموح",
        notAllowed: "غير مسموح",
        on: "تشغيل",
        off: "إيقاف",
        delete: "حذف",
        language: "اللغة"          // ar

    },
    es: {
        darkMode: "Modo Oscuro",
        lightMode: "Modo Claro",
        colorTheme: "Tema",
        playbackSettings: "Reproducción",
        playtime: "Repro",
        autoPlayNext: "Auto-Repro",
        minVotes: "Votos Mín.",
        displaySettings: "Pantalla",
        fontSize: "Fuente",
        highContrast: "Contraste",
        hideBalance: "Ocultar Saldo",
        reset: "Reiniciar",
        join: "Unirse",
        joinPlaylist: "Unirse Playlist",
        create: "Crear",
        createPlaylist: "Crear Playlist",
        activity: "Actividad",
        suggest: "Sugerir",
        suggestSongs: "Sugerir Canciones",
        queue: "Cola",
        choosePlaylist: "Elegir Playlist",
        yourLibrary: "Biblioteca",
        suggestions: "Sugerencias",
        recentlyJoined: "Reciente",
        joined: "Unido",
        mySessions: "Mis sesiones",
        noSessions: "Aún no hay sesiones",
        publicPlaylists: "Playlists Públicas",
        playlistsHistory: "Historial",
        recentActivities: "Actividad",
        songSuggestions: "Canciones Sugeridas",
        "Min Celebration Vote": "Voto 🎉 Mín.",
        panel: "Panel",
        loadingPlaylists: "Cargando playlists...",
        viewDetails: "Ver detalles",
        removeSong: "Quitar canción",
        noSongs: "Sin canciones",
        search: "Buscar",
        "Max Suggestions": "Sug. Máx.",
        "Allow Guests Add Songs": "Permitir Invitados",
        allowGuestAdd: "Permitir Invitados",
        allowed: "Sí",
        notAllowed: "No",
        on: "Activado",
        off: "Desact.",
        language: "Idioma",
        delete: "Eliminar",
    },


    "zh-CN": {
        darkMode: "深色模式",
        lightMode: "浅色模式",
        colorTheme: "颜色主题",
        playbackSettings: "播放设置",
        playtime: "播放时间",
        autoPlayNext: "自动播放下一首",
        minVotes: "最少投票数",
        displaySettings: "显示设置",
        fontSize: "字体大小",
        highContrast: "高对比度模式",
        hideBalance: "隐藏余额",
        reset: "恢复默认",
        join: "加入",
        joinPlaylist: "加入播放列表",
        create: "创建",
        createPlaylist: "创建播放列表",
        activity: "活动",
        suggest: "建议",
        suggestSongs: "建议歌曲",
        queue: "队列",
        choosePlaylist: "选择播放列表",
        yourLibrary: "你的资料库",
        suggestions: "建议",
        recentlyJoined: "最近加入",
        joined: "已加入",
        mySessions: "我的会话",
        noSessions: "暂无会话",
        publicPlaylists: "公开播放列表",
        playlistsHistory: "播放列表历史",
        recentActivities: "最近活动",
        songSuggestions: "歌曲推荐",
        "Min Celebration Vote": "庆祝最低投票数",

        panel: "面板",
        loadingPlaylists: "正在加载您的播放列表...",
        viewDetails: "查看详情",
        removeSong: "移除歌曲",
        noSongs: "没有可用的歌曲",
        search: "搜索",
        "Max Suggestions": "最大建议数",
        "Allow Guests Add Songs": "允许访客添加歌曲",
        allowGuestAdd: "允许访客添加歌曲",
        allowed: "允许",
        notAllowed: "不允许",
        on: "开启",
        off: "关闭",
        language: "语言",          // zh-CN
        delete: "删除",
    },

    hi: {
        darkMode: "डार्क मोड",
        lightMode: "लाइट मोड",
        colorTheme: "रंग थीम",
        playbackSettings: "प्लेबैक सेटिंग्स",
        playtime: "प्ले समय",
        autoPlayNext: "ऑटो-प्ले अगला",
        minVotes: "न्यूनतम वोट",
        displaySettings: "डिस्प्ले सेटिंग्स",
        fontSize: "फ़ॉन्ट आकार",
        highContrast: "उच्च कंट्रास्ट मोड",
        hideBalance: "बैलेंस छिपाएं",
        reset: "रीसेट करें",
        join: "शामिल हों",
        joinPlaylist: "प्लेलिस्ट में शामिल हों",
        create: "बनाएं",
        createPlaylist: "प्लेलिस्ट बनाएं",
        activity: "गतिविधि",
        suggest: "सुझाव दें",
        suggestSongs: "गाने सुझावें",
        queue: "कतार",
        choosePlaylist: "प्लेलिस्ट चुनें",
        yourLibrary: "आपकी लाइब्रेरी",
        suggestions: "सुझाव",
        recentlyJoined: "हाल ही में शामिल हुए",
        joined: "शामिल",
        mySessions: "मेरे सत्र",
        noSessions: "अभी तक कोई सत्र नहीं",
        publicPlaylists: "सार्वजनिक प्लेलिस्ट",
        playlistsHistory: "प्लेलिस्ट इतिहास",
        recentActivities: "हाल की गतिविधियाँ",
        songSuggestions: "गाने सुझाव",
        "Min Celebration Vote": "न्यूनतम जश्न वोट",

        panel: "पैनल",
        loadingPlaylists: "आपकी प्लेलिस्ट लोड हो रही है...",
        viewDetails: "विवरण देखें",
        removeSong: "गाना हटाएं",
        noSongs: "कोई गाने उपलब्ध नहीं हैं",
        search: "खोजें",
        "Max Suggestions": "अधिकतम सुझाव",
        "Allow Guests Add Songs": "मेहमानों को गाने जोड़ने की अनुमति दें",
        allowGuestAdd: "मेहमानों को गाने जोड़ने दें",
        allowed: "अनुमत",
        notAllowed: "निषिद्ध",
        on: "चालू",
        off: "बंद",
        language: "भाषा",         // hi
        delete: "हटाएं",
    },

};
